<template>
  <!-- 等级测试弹窗 -->
  <div class="dialog">
    <el-dialog
      :title="$t('level_dialog_title')"
      :visible="syncVisible"
      :before-close="handleClose"
      @close="close"
      width="940px"
      height="280px"
    >
      <span class="dialog-content">{{ $t('level_dialog_content') }}</span>
      <span slot="footer" class="dialog-footer">
        <mui-button type="yellow" class="btn-yellow btn-submit" @click="jumpLink">{{
          userLogged ? $t('level_dialog_start') : $t('level_dialog_login')
        }}</mui-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import analytics from '@/utils/AnalyticsCenter'
export default {
  name: 'DialogTest',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 用户是否已登录
    userLogged() {
      return this.$store.state.user.given_name || this.$store.state.user.nickname || false
    },
    // 弹窗是否可见
    syncVisible: {
      get() {
        return this.visible
      },
      set(newValue) {
        this.$emit('update:visible', newValue) // 向父组件发出事件来更新 prop
      },
    },
  },
  methods: {
    // 免费测试页面跳转
    jumpLink() {
      if (!this.userLogged) {
        const params = {
          type: 'sign',
        }
        analytics.logEvent('hskweb_leveltestsign_click', params)
      }
      this.$router.push({
        name: 'spcExamination',
      })
      this.syncVisible = false
    },
    handleClose() {
      if (!this.userLogged) {
        const params = {
          type: 'cancel',
        }
        analytics.logEvent('hskweb_leveltestsign_click', params)
      }
      this.syncVisible = false
    },
    // 关闭弹窗的回调
    close() {
      this.syncVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog .el-dialog__wrapper {
  display: flex;
  align-items: center;
  ::v-deep .el-dialog {
    margin-top: 0 !important;
    .el-dialog__header {
      display: flex;
      align-items: center;
      height: 72px;
      border-bottom: 1px solid #efeff1;
      padding: 20px !important;
      .el-dialog__title {
        color: #000;
        font-family: Inter;
        font-size: 18px;
        font-weight: 700;
      }
      .el-dialog__headerbtn {
        .el-dialog__close {
          color: #000;
          font-size: 24px;
          margin-top: 5px;
        }
      }
    }
    .el-dialog__body {
      padding: 45px 75px 30px;
      .dialog-content {
        color: #000;
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-weight: 400;
        word-break: break-word;
      }
    }
    .el-dialog__footer {
      display: flex;
      justify-content: center;
      .btn-yellow {
        display: flex;
        width: 320px;
        padding: 12px 24px;
        flex-direction: column;
        align-items: center;
        color: #fff;
        text-align: center;
        font-family: Inter;
        font-size: 20px;
        font-weight: 600;
        line-height: 140%; /* 28px */
      }
    }
  }
}
</style>
